import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiNotificationComponent } from './ui-notification.component';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from '../message/message.module';

@NgModule({
  declarations: [UiNotificationComponent],
  exports: [ToastModule, UiNotificationComponent],
  imports: [MessageModule, CommonModule, ToastModule],
})
export class UiNotificationModule {}
